<template>
  <div class="t-userListEdit t-srcollbar">
    <div class="t-input" :class="{_error: userLink.error}">
        <label>{{ addNewUsersLink.title }}</label>
        <input type="text" v-model="userLink.value" @keyup.enter.prevent="AddUserToList()">
    </div>
    <div class="t-userList ">
        <label v-for="item in usersInObj" :key="item.id" class="t-userItem__wrapper">
            <cmp-userItem :user="item" >
                <template slot="info">
                    <div>
                        <input class="t-checkbox" :id="'checkbox'+item.id" type="checkbox" :checked="item.checked" @change="changeCheckbox(item)">
                        <label :for="'checkbox'+item.id"></label>
                    </div>
                </template>
            </cmp-userItem>
        </label>
    </div>
  </div>
</template>

<script>
    import {store} from '../store'

    import UserItem from './UserItem.vue'
    import {mapGetters, mapActions} from 'vuex';

    export default {
        data(){
            return{
                userLink: {
                    value:'',
                    error: false
                }
            }
        },
        props: {
            load: {
                type: Boolean,
                default: false
            }
        },
        components: {
            'cmp-userItem': UserItem
        },
        computed: {
            ...mapGetters(['mobile']),
            ...mapGetters('staticText', ['addNewUsersLink']),
            ...mapGetters('dialog', ['contactsList']),
            usersInObj() {
                if (this.load) {
                    return this.contactsList
                } else {
                    return {};
                }
            }
        },
        methods: {
            ...mapActions('msg', ['showMsg']),
            ...mapActions('dialog', ['LoadContactsList', 'AddNewContactsList', 'ChangeDialogContactsList']),
            AddUserToList(){
                let arr = this.userLink.value.split('/')
                this.AddNewContactsList(arr[arr.length - 1])
                    .then(
                        ()=>{
                            this.userLink.value = '';
                        },
                        ()=>{
                            this.showMsg(this.addNewUsersLink.errorMsg);
                        }
                    )
            },
            changeCheckbox(item){
                let newItem =  Object.assign({}, {}, item);
                newItem.checked = !item.checked;
                this.ChangeDialogContactsList(newItem)
            },
        }
    }
</script>

<style lang="sass">
.t-userListEdit
    width: 100%
.t-userList
    max-height: 300px
    overflow-y: scroll
    overflow-x: hidden
    position: relative
    &:after
        content: ''
        display: block
        background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);
        width: 100%
        height: 74px
        position: sticky
        bottom: 0
        left: 0
</style>


// WEBPACK FOOTER //
// src/vue_components/UsersListEdit.vue